import REQUEST from "@/utils/httpRequest";
import { Message, MessageBox } from "element-ui";

export const versionKey = "CGPT_LASTBUILDTIMESTAMP";

export function getVersion() {
    return REQUEST(`${window.location.origin}/static/version.json`).catch(
        err => err
    );
}

export function refreshLocalFEVersion() {
    const { lastBuildTimeStamp } = require("../../static/version.json");
    localStorage.setItem(versionKey, lastBuildTimeStamp);
}

export function checkFrontEndVersion() {
    return getVersion().then(res => {
        if (res.lastBuildTimeStamp) {
            const localLastBuildTimeStamp = localStorage.getItem(versionKey);
            // 注意此处 lastBuildTimeStamp是string类型,res.lastBuildTimeStamp是number类型
            if (localLastBuildTimeStamp != res.lastBuildTimeStamp) {
                MessageBox.confirm("当前版本已更新，请刷新后使用。", "提示", {
                    confirmButtonText: "刷新",
                    type: "warning"
                }).then(() => {
                    window.location.reload(true);
                });
            }
        } else {
            Message.error({
                showClose: true,
                message: "前端页面异常,请联系管理员",
                type: "error"
            });
            return Promise.reject();
        }
    });
}



// WEBPACK FOOTER //
// ./src/api/checkVersion.js